import React, { PureComponent, ReactNode } from "react";
import generateIntervalQuestions from "../../../functions/generateIntervalQuestions";
import { IntervalQuizSettings } from "../../../models/IntervalQuizSettings.model";
import { QuizQuestion } from "../../../models/QuizQuestion.model";
import MultipleChoiceForm from "../../generic/MultipleChoiceForm";
import IntervalQuizSettingsPicker from "./IntervalQuizSettingsPicker";
enum QuizLifecycleStage {
  ChooseSettings,
  AnswerQuestions,
  ReviewResults,
}
interface Props {}
interface State {
  stage: QuizLifecycleStage;
  questions?: Array<QuizQuestion>;
  currentQuestionIndex: number;
}

class IntervalQuizSequencer extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      stage: QuizLifecycleStage.ChooseSettings,
      questions: undefined,
      currentQuestionIndex: 0,
    };
  }

  handleQuizSettingsSubmit = ({ settings }: { settings: IntervalQuizSettings }) => {
    const questions = generateIntervalQuestions(settings);
    // console.log("debug qs", questions);
    this.setState({
      questions,
      stage: QuizLifecycleStage.AnswerQuestions,
    });
  };

  handleQuizAnswer = (answer: string) => {
    const { questions, currentQuestionIndex } = this.state;
    // console.log(
    //   "given answer: " +
    //     answer +
    //     " -- correct answer: " +
    //     questions![currentQuestionIndex].correctAnswer
    // );
    if (answer === questions![currentQuestionIndex].correctAnswer) {
      // options for temporary "answer assessment visuals" state
      //  A: set a timeout to complete the transition to next step
      //    Con: not flexible to eventual 2 click solution
      //  B: another peice of state to highlight the correct answer (vs. whatever clicked).  The resolution of which goes to next Q
      alert("Correct!"); // motivation to make UI
      if (currentQuestionIndex < questions!.length - 1) {
        this.setState({
          currentQuestionIndex: currentQuestionIndex + 1,
        });
      } else {
        this.setState({
          currentQuestionIndex: 0,
          stage: QuizLifecycleStage.ReviewResults,
        });
      }
    } else {
      alert("WRONG BAD NO GO TO JAIL SHAME SHAME");
    }
  };

  render(): ReactNode {
    const { stage, questions, currentQuestionIndex } = this.state;
    if (stage === QuizLifecycleStage.ChooseSettings) {
      return <IntervalQuizSettingsPicker onContinue={this.handleQuizSettingsSubmit} />;
    }
    if (stage === QuizLifecycleStage.AnswerQuestions && questions) {
      return <MultipleChoiceForm question={questions[currentQuestionIndex]} onSubmitAnswer={this.handleQuizAnswer} />;
    }
    if (stage === QuizLifecycleStage.ReviewResults) {
      return <div>success, you win!  refresh to play again</div>;
    }
    return <div>this should never appear</div>;
  }
}

export default IntervalQuizSequencer;
